import React, { useEffect, useRef } from "react";

function ConsultantGraphs({consultantsStats = {}}) {

  return (
    <>
      

      <div className="grid grid-cols-3 mb-8 space-x-4 mt-8">
        {/* Total Consultants */}
        <div className="flex flex-col items-center justify-center bg-white p-12 rounded-lg shadow-lg">
          <h3 className="text-gray-500 text-2xl font-semibold mt-4">
            Total Consultants: {consultantsStats?.total}
          </h3>
          {/* <span className="text-blue-500 text-2xl font-bold mt-4 mb-4">23</span> */}
        </div>
        <div className="flex flex-col items-center justify-center bg-white p-12 rounded-lg shadow-lg">
          <h3 className="text-blue-500 text-2xl font-semibold mt-4">
            Assigned Consultants: {consultantsStats?.engaged}
          </h3>
          {/* <span className="text-green-500 text-2xl font-bold mt-4 mb-4">23</span> */}
        </div>
        <div className="flex flex-col items-center justify-center bg-white p-12 rounded-lg shadow-lg">
          <h3 className="text-red-500 text-2xl font-semibold mt-4">
            Unassigned Consultants: {consultantsStats?.total - consultantsStats?.engaged}
          </h3>
          {/* <span className="text-red-500 text-2xl font-bold mt-4 mb-4">23</span> */}
        </div>
      </div>

      
    </>
  );
}

export default ConsultantGraphs;
 